@use '../revamp-table-root' as *;

@layer design-system {
  .root {
    @include revamp-table-root;
  }
}
